import React, { useState } from 'react';
import { useNavigate, useInRouterContext } from 'react-router-dom';
import {
  Container,
  Grid,
  Paper,
  Typography,
  Box,
  Button,
  Card,
  CardContent,
  Slider,
  Switch,
  FormControlLabel,
  Divider,
  Chip,
  Tabs,
  Tab,
  Alert,
  Tooltip,
} from '@mui/material';

const XAISandbox = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [showExplanation, setShowExplanation] = useState(true);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          🧠 XAI Sandbox
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Explainable AI visualization and analysis sandbox for model interpretability.
        </Typography>
        <Button variant="outlined" onClick={handleGoBack} sx={{ mt: 2 }}>
          ← Back
        </Button>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Model Explanation
            </Typography>
            <Divider sx={{ mb: 2 }} />
            {showExplanation ? (
              <Box>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  This section displays feature importance, SHAP values, and other explainability metrics.
                </Typography>
                <Box sx={{ mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                  <Typography variant="subtitle2">Feature Importance</Typography>
                  <Box sx={{ mt: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <Typography variant="caption" sx={{ width: 100 }}>Feature A</Typography>
                      <Box sx={{ flex: 1, height: 8, bgcolor: '#e0e0e0', borderRadius: 4, mx: 1 }}>
                        <Box sx={{ width: '85%', height: 8, bgcolor: '#1976d2', borderRadius: 4 }} />
                      </Box>
                      <Typography variant="caption">0.85</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <Typography variant="caption" sx={{ width: 100 }}>Feature B</Typography>
                      <Box sx={{ flex: 1, height: 8, bgcolor: '#e0e0e0', borderRadius: 4, mx: 1 }}>
                        <Box sx={{ width: '60%', height: 8, bgcolor: '#2e7d32', borderRadius: 4 }} />
                      </Box>
                      <Typography variant="caption">0.60</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography variant="caption" sx={{ width: 100 }}>Feature C</Typography>
                      <Box sx={{ flex: 1, height: 8, bgcolor: '#e0e0e0', borderRadius: 4, mx: 1 }}>
                        <Box sx={{ width: '35%', height: 8, bgcolor: '#ed6c02', borderRadius: 4 }} />
                      </Box>
                      <Typography variant="caption">0.35</Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            ) : (
              <Typography color="text.secondary">Explanation hidden</Typography>
            )}
          </Paper>
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Controls
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <FormControlLabel
              control={
                <Switch
                  checked={showExplanation}
                  onChange={() => setShowExplanation(!showExplanation)}
                />
              }
              label="Show Explanation"
            />
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" gutterBottom>Confidence Threshold</Typography>
              <Slider
                defaultValue={0.5}
                min={0}
                max={1}
                step={0.05}
                valueLabelDisplay="auto"
              />
            </Box>
            <Button variant="contained" fullWidth sx={{ mt: 2 }}>
              Generate New Explanation
            </Button>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              📊 Analysis Details
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="caption" color="text.secondary">Model</Typography>
                    <Typography variant="body1">Acoustic Encoder v1</Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="caption" color="text.secondary">Confidence</Typography>
                    <Typography variant="body1" color="success.main">0.87</Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="caption" color="text.secondary">Prediction</Typography>
                    <Typography variant="body1" color="error.main">TB</Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default XAISandbox;
